import { useUserPortfolioList } from './useUserPortfolioList';

export function useCancelledSubscriptions(enabled = true) {
  return useUserPortfolioList({
    variables: {
      investment_status: 'invested',
      status: 'inactive',
    },
    enabled,
  });
}
